export default "__VITE_ASSET__BRxPe72f__"